import React from "react";
import MagazineManagementMain from "../../components/MagazineManagementMain";

const MagazineManagementPage = () => {
  return (
    <React.Fragment>
      <MagazineManagementMain />
    </React.Fragment>
  );
};

export default MagazineManagementPage;
